import React, { useState } from "react";
import { FieldArray, useFormikContext } from "formik";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Table } from "react-bootstrap";
import {
  FormArraySelectField,
  FormArrayTextField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import Illustration from "../../../../../partials/content/Illustration";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SearchGlAccount from "../../../setup/finance/searchGlAccount";
import { DialogActions } from "@material-ui/core";

function JournalEntriesItem(props) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedItemIndex, setSelectedItemIndex] = useState(-1);
  const [openSearchGlAccount, setOpenSearchGlAccount] = useState(false);
  const [accountTypeID, setAccountTypeID] = useState(0);
  const { values, setFieldValue } = useFormikContext();

  return (
    <React.Fragment>
      <div className="accordion">
        <div className="card">
          <Accordion
            className="accordion"
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
          >
            <AccordionTab
              header={
                <React.Fragment>
                  <i className="fas fa-sitemap"></i>
                  <span>
                    <strong>Journal Items</strong>
                  </span>
                </React.Fragment>
              }
            >
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <FieldArray name="accountingItems">
                    {({ push, remove }) => (
                      <React.Fragment>
                        <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-12">
                            <div className="card">
                              <Table borderless size="sm" responsive="xl">
                                {values.accountingItems &&
                                values.accountingItems.length > 0 ? (
                                  <thead className="text-center">
                                    <tr>
                                      <th style={{ width: "25%" }}>Account</th>
                                      <th style={{ width: "10%" }}>
                                        D/C Indicator
                                      </th>
                                      <th style={{ width: "15%" }}>Debit</th>
                                      <th style={{ width: "15%" }}>Credit</th>
                                      <th style={{ width: "30%" }}>Note</th>
                                      <th>Actions</th>
                                    </tr>
                                  </thead>
                                ) : null}
                                <tbody>
                                  {values.accountingItems &&
                                  values.accountingItems.length > 0 ? (
                                    values.accountingItems.map(
                                      (item, index) => {
                                        return (
                                          <tr key={index}>
                                            <td>
                                              <FormArrayTextField
                                                arrayPropName="accountingItems"
                                                index={index}
                                                propName="accountName"
                                                searchButton={
                                                  values.dividend ? false : true
                                                }
                                                readonly
                                                onSearchClick={() => {
                                                  setSelectedItemIndex(index);
                                                  setOpenSearchGlAccount(true);
                                                }}
                                                margin="none"
                                              />
                                            </td>
                                            <td>
                                              <FormArraySelectField
                                                arrayPropName="accountingItems"
                                                propName="dbInd"
                                                index={index}
                                                margin="none"
                                                onSelectChange={(value) => {
                                                  setAutoJournalItem(
                                                    item.accountID,
                                                    item.accountName,
                                                    item.predID,
                                                    item.accountTypeID,
                                                    value
                                                  );
                                                }}
                                                options={[
                                                  {
                                                    label: "Debit",
                                                    value: "D",
                                                  },
                                                  {
                                                    label: "Credit",
                                                    value: "C",
                                                  },
                                                ]}
                                              />
                                            </td>
                                            <td>
                                              <FormArrayTextField
                                                arrayPropName="accountingItems"
                                                index={index}
                                                propName="damount"
                                                currencyField
                                                onBlur={() => {
                                                  calculateTotalAmountDebitCredit(
                                                    values,
                                                    setFieldValue
                                                  );
                                                }}
                                                margin="none"
                                                readonly={
                                                  item.dbInd === "C" ||
                                                  values.dividend
                                                    ? true
                                                    : false
                                                }
                                              />
                                            </td>
                                            <td>
                                              <FormArrayTextField
                                                arrayPropName="accountingItems"
                                                index={index}
                                                propName="camount"
                                                currencyField
                                                onBlur={() => {
                                                  calculateTotalAmountDebitCredit(
                                                    values,
                                                    setFieldValue
                                                  );
                                                }}
                                                margin="none"
                                                readonly={
                                                  item.dbInd === "D"
                                                    ? true
                                                    : false
                                                }
                                              />
                                            </td>
                                            <td>
                                              <FormArrayTextField
                                                arrayPropName="accountingItems"
                                                index={index}
                                                propName="note"
                                                margin="none"
                                              />
                                            </td>
                                            <td
                                              style={{ whiteSpace: "nowrap" }}
                                              className="text-center"
                                            >
                                              {!values.dividend &&
                                              !values.autoItem ? (
                                                <BootstrapTooltip
                                                  title={"Delete Journal Item"}
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-icon btn-label-danger btn-md btn-circle mx-1"
                                                    onClick={() => {
                                                      remove(index);
                                                      calculateTotalAmountDebitCredit(
                                                        values,
                                                        setFieldValue
                                                      );
                                                    }}
                                                  >
                                                    <i className="fas fa-trash-alt"></i>
                                                  </button>
                                                </BootstrapTooltip>
                                              ) : null}
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )
                                  ) : (
                                    <tr>
                                      <td
                                        className="text-center py-3"
                                        colSpan="6"
                                      >
                                        <Illustration
                                          imageSource="INVIFO Payment.png"
                                          guidance="You don't have any Journal items yet"
                                          guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                          size="sm"
                                        ></Illustration>
                                      </td>
                                    </tr>
                                  )}
                                  <tr>
                                    <td
                                      className="text-center py-3"
                                      colSpan="6"
                                    >
                                      {!values.dividend && !values.autoItem ? (
                                        <button
                                          type="button"
                                          className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                                          onClick={() => {
                                            push({
                                              accountID: 0,
                                              accountTypeID: 0,
                                              predID: 0,
                                              accountName: "",
                                              dbInd: "D",
                                              damount: 0,
                                              camount: 0,
                                              amount: 0,
                                              note: "",
                                            });
                                          }}
                                        >
                                          <i className="fas fa-plus-circle"></i>
                                          Add Item
                                        </button>
                                      ) : null}
                                    </td>
                                  </tr>
                                </tbody>
                                {values.accountingItems &&
                                values.accountingItems.length > 0 ? (
                                  <tfoot>
                                    <tr>
                                      <td></td>
                                      <td></td>
                                      <td>
                                        <FormTextField
                                          label="Total Debit"
                                          name="totalDebit"
                                          currencyField
                                          readonly
                                        />
                                      </td>
                                      <td>
                                        <FormTextField
                                          label="Total Credit"
                                          name="totalCredit"
                                          currencyField
                                          readonly
                                        />
                                      </td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                  </tfoot>
                                ) : null}
                              </Table>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                  </FieldArray>
                </div>
              </div>
            </AccordionTab>
          </Accordion>
        </div>
      </div>
      <DialogLayout
        open={openSearchGlAccount}
        title="Search GL Account"
        onCloseDialog={() => {
          setOpenSearchGlAccount(false);
        }}
        maxWIdth="md"
      >
        <SearchGlAccount
          accountTypeID={accountTypeID}
          onSelectGlAccount={(account) => {
            let accountingItems = [];
            setFieldValue(
              `accountingItems[${selectedItemIndex}].accountID`,
              account.ID
            );
            setFieldValue(
              `accountingItems[${selectedItemIndex}].predID`,
              account.predID
            );
            setFieldValue(
              `accountingItems[${selectedItemIndex}].accountTypeID`,
              account.accountTypeID
            );
            setFieldValue(
              `accountingItems[${selectedItemIndex}].accountName`,
              account.accountName
            );
            if (account.accountTypeID === 8 || account.accountTypeID === 11) {
              setAccountTypeID(1);
              let dbInd = "";
              if (account.accountTypeID === 8) {
                dbInd = "D";
              } else if (account.accountTypeID === 11) {
                dbInd = "C";
              }
              accountingItems.push({
                accountID: account.ID,
                accountTypeID: account.accountTypeID,
                predID: account.predID,
                accountName: account.accountName,
                dbInd: dbInd,
                damount: 0,
                camount: 0,
                amount: 0,
                note: "",
              });
              if (account.accountTypeID === 8) {
                dbInd = "C";
              } else if (account.accountTypeID === 11) {
                dbInd = "D";
              }
              accountingItems.push({
                accountID: 0,
                accountTypeID: 0,
                predID: 0,
                accountName: "",
                dbInd: dbInd,
                damount: 0,
                camount: 0,
                amount: 0,
                note: "",
              });
              setFieldValue("accountingItems", accountingItems);
              setFieldValue("dividend", false);
              setFieldValue("autoItem", true);
              setFieldValue("totalDebit", 0);
              setFieldValue("totalCredit", 0);
              setFieldValue("totalAmount", 0);
            } else {
              setAccountTypeID(0);
            }
            setOpenSearchGlAccount(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchGlAccount(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  function setAutoJournalItem(
    accountID = 0,
    accountName = "",
    accountPredID = 0,
    accountTypeID = 0,
    dbInd = "D"
  ) {
    let accountingItems = [];
    if (accountPredID === 27 && dbInd === "C") {
      setAccountTypeID(0);
      accountingItems.push({
        accountID: values.divGlAccountID,
        accountTypeID: 0,
        predID: 0,
        accountName: values.divGlAccountName,
        dbInd: "C",
        damount: 0,
        camount: 0,
        amount: 0,
        note: "",
      });
      accountingItems.push({
        accountID: 0,
        accountTypeID: 0,
        predID: 0,
        accountName: "Retained Earnings",
        dbInd: "D",
        damount: 0,
        camount: 0,
        amount: 0,
        note: "",
      });
      setFieldValue("accountingItems", accountingItems);
      setFieldValue("dividend", true);
      setFieldValue("autoItem", false);
      setFieldValue("totalDebit", 0);
      setFieldValue("totalCredit", 0);
      setFieldValue("totalAmount", 0);
    } else if (
      (accountTypeID === 8 && dbInd === "D") ||
      (accountTypeID === 11 && dbInd === "C")
    ) {
      setAccountTypeID(1);
      let dbInd = "";
      if (accountTypeID === 8) {
        dbInd = "D";
      } else if (accountTypeID === 11) {
        dbInd = "C";
      }
      accountingItems.push({
        accountID: accountID,
        accountTypeID: accountTypeID,
        predID: accountPredID,
        accountName: accountName,
        dbInd: dbInd,
        damount: 0,
        camount: 0,
        amount: 0,
        note: "",
      });
      if (accountTypeID === 8) {
        dbInd = "C";
      } else if (accountTypeID === 11) {
        dbInd = "D";
      }
      accountingItems.push({
        accountID: 0,
        accountTypeID: 0,
        predID: 0,
        accountName: "",
        dbInd: dbInd,
        damount: 0,
        camount: 0,
        amount: 0,
        note: "",
      });

      setFieldValue("accountingItems", accountingItems);
      setFieldValue("dividend", false);
      setFieldValue("autoItem", true);
      setFieldValue("totalDebit", 0);
      setFieldValue("totalCredit", 0);
      setFieldValue("totalAmount", 0);
    } else {
      if (values.dividend || values.autoItem) {
        setAccountTypeID(0);
        accountingItems = [...values.accountingItems];
        accountingItems.splice(1, 1);
        setFieldValue("accountingItems", accountingItems);
        setFieldValue("dividend", false);
        setFieldValue("autoItem", false);
      }
    }
  }

  function calculateTotalAmountDebitCredit() {
    let totalDebitAmount = 0;
    let totalCreditAmount = 0;
    let totalAmount = 0;
    let dividendAmount = 0;
    const accountingItems = [...values.accountingItems];
    for (const accountingItem of accountingItems) {
      if (accountingItem.dbInd === "D") {
        if (dividendAmount > 0) {
          totalDebitAmount += dividendAmount;
          totalAmount += dividendAmount;
          accountingItem.damount = dividendAmount;
        } else {
          totalDebitAmount += parseFloat(accountingItem.damount);
          totalAmount += parseFloat(accountingItem.damount);
        }
      } else if (accountingItem.dbInd === "C") {
        totalCreditAmount += parseFloat(accountingItem.camount);
        if (values.dividend) {
          dividendAmount = parseFloat(accountingItem.camount);
        }
      }
    }
    //setFieldValue("accountingItems", accountingItems);
    setFieldValue("totalDebit", totalDebitAmount);
    setFieldValue("totalCredit", totalCreditAmount);
    setFieldValue("totalAmount", totalAmount);
  }
}

export default JournalEntriesItem;
